module.exports = __webpack_public_path__ + "img/3.e81b3708.jpg";